import { defineStore } from "pinia";
import { ref } from "vue";
import { storage } from "/@/cool/utils";
import { service } from "/@/cool";

// 本地缓存
const data = storage.info();

export const useProductStore = defineStore("product", function () {
	const buyTypeCateList = ref<any[]>(data["product.buyTypeCateList"] || []);

	// 设置菜单组
	function setBuyTypeCateList(list: any) {
		buyTypeCateList.value = list;
		storage.set("product.buyTypeCateList", list);
	}

	async function getBuyTypeCateList() {
		// 检查 service 和 buyTypeCate 是否存在
		if (!service || !service.buyTypeCate) {
			console.warn("service.buyTypeCate 尚未初始化");
			return [];
		}
		const res = await service.buyTypeCate.list({ is_active: 1 });
		const ret = (res || []).map((item: any) => ({
			label: item.cate_name,
			value: item.id
		}));
		return ret;
	}

	function loadBuyTypeCateList() {
		getBuyTypeCateList().then((res) => {
			setBuyTypeCateList(res);
		}).catch((err) => {
			console.error("加载 buyTypeCateList 失败:", err);
		});
	}

	return {
		getBuyTypeCateList,
		setBuyTypeCateList,
		buyTypeCateList,
		loadBuyTypeCateList,
		refreshBuyTypeCateList: loadBuyTypeCateList
	};
});
